import { useState } from 'react';
import type { SimulationRow, PropertySpec } from '../types/spec';

interface Props {
  rows: SimulationRow[];
  specs: PropertySpec[];
}

const MAX_PREVIEW = 100;

export default function SimulationPreview({ rows, specs }: Props) {
  const [showAll, setShowAll] = useState(false);
  const included = specs.filter((s) => s.included);
  const displayRows = showAll ? rows : rows.slice(-MAX_PREVIEW);

  if (rows.length === 0) {
    return null;
  }

  return (
    <section className="ds-sim-preview">
      <div className="ds-sim-preview-header">
        <h3>Simulation Data Preview</h3>
        <span className="ds-sim-preview-info">
          Showing {displayRows.length} of {rows.length} rows
          {rows.length > MAX_PREVIEW && !showAll && (
            <button className="ds-btn-link" onClick={() => setShowAll(true)}>
              Show all
            </button>
          )}
          {showAll && rows.length > MAX_PREVIEW && (
            <button className="ds-btn-link" onClick={() => setShowAll(false)}>
              Show latest {MAX_PREVIEW}
            </button>
          )}
        </span>
      </div>

      <div className="ds-sim-table-wrap">
        <table className="ds-sim-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Timestamp</th>
              {included.map((s) => (
                <th key={s.name}>{s.displayName}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {displayRows.map((row, i) => {
              const rowIndex = showAll
                ? i + 1
                : rows.length - displayRows.length + i + 1;
              return (
                <tr key={i}>
                  <td className="ds-cell-rownum">{rowIndex}</td>
                  <td className="ds-cell-ts">
                    {new Date(row.timestamp).toLocaleTimeString()}
                  </td>
                  {included.map((s) => {
                    const isAnomaly = row.anomalyFlags[s.name];
                    const val = row.values[s.name];
                    return (
                      <td
                        key={s.name}
                        className={isAnomaly ? 'ds-cell-anomaly-value' : ''}
                        title={isAnomaly ? 'Anomaly' : ''}
                      >
                        {val !== null && val !== undefined ? String(val) : 'null'}
                        {isAnomaly && <span className="ds-anomaly-flag"> ⚠</span>}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}
